import { watch } from "vue"

/**
 * Creates a watch to fill in the fields when the current answers are updated
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Function} cancels the watch when executed
 */
export function createAnswerDetailsWatch(data, form){
    watch(data.answers.details, (updatedAnswers) => {
        Object.keys(updatedAnswers)
            .forEach((key) => {
                if(!form.fields.value.fields[key]){
                    form.fields.value.fields[key] = updatedAnswers[key]
                }
            })
    }, { deep: true, immediate: true })
}